<template>
    <div class="fixed-scroller">
        <div class="v-alert" style="width:600px;margin-left:-300px;top:90px;">
            <header><p>Edit Staff</p><div class="x" @click="emit('exit')"></div></header>
            <div>
                <div class="label">
                    <p>Name</p>
                    <input v-model="staff.name" />
                </div>
                <div class="label">
                    <p>Username</p>
                    <input v-model="staff.username" />
                </div>
                <div class="label">
                    <p>Email</p>
                    <input v-model="staff.email" />
                    <p class="btn" style="display: none;" @click="sendInvite('email',staff)">send invite</p>
                </div>
                <div class="label">
                    <p>Mobile</p>
                    <input v-model="staff.mobile" />
                    <p class="btn" style="display: none;" @click="sendInvite('sms',staff)">send invite</p>
                </div>

                <div class="label checkbox">
                    <p>Suspend</p>
                    <input v-model="staff.suspend" type="checkbox" />
                </div>
                <div class="label checkbox">
                    <p>Dashboard</p>
                    <input v-model="staff.dashboard" type="checkbox" />
                </div>
                <div class="label" style="display: none;">
                    <p>Notes</p>
                    <textarea v-model="staff.notes"></textarea>
                </div>
            </div>
            <div class="btns">
                <p class="btn del" @click="emit('delete')">delete</p><p @click="emit('save')" class="btn">save</p>
            </div>
       </div>
    </div>
</template>

<script>

export default {
    name: 'edit-staff',
    props: ['item'],
    data () {
        return {
            staff: {},
            fields: ['name','username','email','mobile','suspend','dashboard','notes','_id']
        }
    },
    mounted () {
        this.fields.forEach(f => {
            this.$set(this.staff,f,this.item[f]);
        })
    },
    methods: {
        emit ( action ) {
            var { staff, item } = this;
            if ( action == 'save' ) {
                var update = this.fields.reduce((p,f) => {
                    if ( item[f] != staff[f] ) p[f] = staff[f];
                    return p; 
                },{});
            }
            this.$emit('emit',{ t: 'edit-staff', action, item: this.staff, update });
        }
    }
}    
</script>